<template>
  <div id="lang">
    <p>
      <b-input-group>
        <b-form-select id="switchClient" v-model="current_client" @change="chooseClient(current_client)" v-bind:value="current_client"
                       size="sm"
                       :plain="true"
                       :options="options"
                       v-if="is_admin"
        >
        </b-form-select>
        <div class="input-group-append">
          <b-input-group-append>
            <button type="button" class="btn float-left" @click="refreshConfig"><i class="fa fa-refresh"></i></button>
          </b-input-group-append>
        </div>
      </b-input-group>
    </p>
  </div>
</template>
<script>
  import Vue from 'vue'
  import * as Cookies from 'js-cookie'

  export default {
    name: 'switchClient',
    data: function () {
      return {
        flag: false,
        is_admin: false,
        current_client: '',
        options: []
      }
    },
    methods: {
      getConfig (client) {
        this.axios.tenant.getClientDetail(client, (response) => {
          this.$store.commit('setConfig', {
            base: {
              id: response.data.data.item.id
            },
            country_code: response.data.data.item.country,
            main: response.data.data.item.main_config,
            manual_config: response.data.data.item.manual_config,
            gms: response.data.data.item.gms_config
          })
          this.$session.set('config', {
            base: {
              id: response.data.data.item.id
            },
            country_code: response.data.data.item.country,
            main: response.data.data.item.main_config,
            manual_config: response.data.data.item.manual_config,
            gms: response.data.data.item.gms_config
          })
          let lang = 'en'
          if (response.data.data.item != null && response.data.data.item.main_config != null && response.data.data.item.main_config.language != null) {
            lang = response.data.data.item.main_config.language[0]
          }
          this.$store.dispatch('setLang', lang)
          this.$session.set('lang', lang)
          Vue.axios.defaults.headers.common['Lang'] = lang
          this.$store.commit('setLang', lang)
          this.$root.$emit('changeLang')
          this.$root.$emit('UpdatedConfig')
          if (navigator.userAgent.includes('Safari')) {
            location.reload()
          } else {
            this.$router.go(this.history)
          }
        }, error => {
          console.log(error)
        })
      },
      refreshConfig: function () {
        let client = localStorage.getItem('clientID')
        this.getConfig(client)
      },
      chooseClient: function (client) {
        if (typeof client !== 'undefined') {
          let clientTmp = localStorage.getItem('clientID')
          localStorage.setItem('clientID', client)
          Vue.axios.defaults.headers.common['Client'] = client
          if (clientTmp !== client) {
            this.getConfig(client)
          }
        }
      }
    },
    created () {
      let vm = this
      // get client list
      let user = this.$auth.user()
      if (typeof user.user_info !== 'undefined') {
        let isAdmin = user.user_info.user.is_admin
        let userId = user.user_info.user.id
        if (userId === 1) {
          isAdmin = true
        }
        vm.is_admin = isAdmin
        if (isAdmin) {
          vm.axios.tenant.getClientsByMe(respone => {
            if (respone.status === 200) {
              let data = respone.data.data.items
              vm.current_client = localStorage.getItem('clientID')
              for (var i = 0; i <= data.length; i++) {
                if (typeof data[i] !== 'undefined') {
                  vm.options.push({text: data[i].name, value: data[i].uuid})
                }
              }
            }
          }, error => {
            console.log('error', error)
          })
        }
      }
    },
    watch: {
      current_client: function (val) {
        this.chooseClient(val)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Partials/SwitchClient.vue